import { createBrowserRouter, Navigate } from 'react-router-dom';
import Layout from '@@/components/Layout';
import PrivateRoute from '@@/components/Layout/PrivateRoute';
import EmbedRoute from '@@/components/Layout/EmbedRoute';
import FallbackPage from '@@/pages/FallbackPage';
import SigninPage from '@@/pages/SigninPage';
import HomePage from '@@/pages/HomePage';
import PropertiesPage from '@@/pages/PropertiesPage';
import PropertyPage from '@@/pages/PropertyPage';
import MessagesPage from '@@/pages/MessagesPage';
import MessagePage from '@@/pages/MessagePage';
import NewMessagePage from '@@/pages/NewMessagePage';
import IncidentsPage from '@@/pages/IncidentsPage';
import IncidentPage from '@@/pages/IncidentPage';
import NewIncidentPage from '@@/pages/NewIncidentPage';
import UserPage from '@@/pages/UserPage';
import TemplateMessagesPage from '@@/pages/TemplateMessagesPage';
import NewTemplateMessagePage from '@@/pages/NewTemplateMessagePage';
import MePage from '@@/pages/MePage';
import ResetPasswordPage from '@@/pages/ResetPasswordPage';
import ChangePasswordPage from '@@/pages/ChangePasswordPage';

const router = createBrowserRouter([
  {
    element: <Layout />,
    errorElement: <FallbackPage />,
    children: [
      {
        path: '/',
        index: true,
        element: <SigninPage />,
      },
      {
        path: '/reset-password',
        element: <ResetPasswordPage />,
      },
      {
        path: '/change-password',
        element: <ChangePasswordPage />,
      },
      {
        path: '/home',
        element: <PrivateRoute />,
        children: [{ index: true, element: <HomePage /> }],
      },
      {
        path: '/properties',
        element: <PrivateRoute />,
        children: [
          {
            index: true,
            element: <PropertiesPage />,
          },
          {
            path: ':propertyId',
            element: <PropertyPage />,
          },
        ],
      },
      {
        path: '/messages',
        element: <PrivateRoute />,
        children: [
          {
            index: true,
            element: <MessagesPage />,
          },
          {
            path: 'new',
            element: <NewMessagePage />,
          },
          {
            path: ':messageId',
            element: <MessagePage />,
          },
        ],
      },
      {
        path: '/template-messages',
        element: <PrivateRoute />,
        children: [
          {
            index: true,
            element: <TemplateMessagesPage />,
          },
          {
            path: 'new',
            element: <NewTemplateMessagePage />,
          },
        ],
      },
      {
        path: '/incidents',
        element: <PrivateRoute />,
        children: [
          {
            index: true,
            element: <IncidentsPage />,
          },
          {
            path: 'new',
            element: <NewIncidentPage />,
          },
          {
            path: ':incidentId',
            element: <IncidentPage />,
          },
        ],
      },
      {
        // Version embarquable des incidents (iframe mon-rdv) : mêmes pages,
        // sans chrome et avec une session fournie par l'application parente.
        path: '/embed/incidents',
        element: <EmbedRoute />,
        children: [
          {
            index: true,
            element: <IncidentsPage />,
          },
          {
            path: 'new',
            element: <NewIncidentPage />,
          },
          {
            path: ':incidentId',
            element: <IncidentPage />,
          },
        ],
      },
      {
        // Sans ce filet, `/embed`, `/embed/autre-chose` ou un lien profond
        // obsolète tomberaient sur le `path: '*'` ci-dessous, qui afficherait
        // le formulaire de connexion partenaire dans l'iframe du tiers.
        path: '/embed/*',
        element: <Navigate to="/embed/incidents" replace />,
      },
      {
        path: '/users/:userId',
        element: <PrivateRoute />,
        children: [
          {
            index: true,
            element: <UserPage />,
          },
        ],
      },
      {
        path: '/me',
        element: <PrivateRoute />,
        children: [{ index: true, element: <MePage /> }],
      },
      {
        path: '*',
        element: <SigninPage />,
      },
    ],
  },
]);

export default router;
